import styled from '@emotion/styled';

const Main = styled('main')`
    flex: 1 0 auto;
    display: block;
    min-height: calc(100vh - 50px - 38px - 50px);
`;

export default Main;
